import { CountryPrefix } from 'Jsx/global';

import { CountryProps } from '../types';

import {
  getLabel,
  getMask,
  getValidation,
  getDocumentTypes,
  getInputMode,
} from '.';

export const getCountryProps = (countryPrefix: CountryPrefix): CountryProps => {
  return {
    label: getLabel(countryPrefix),
    mask: getMask(countryPrefix),
    validation: getValidation(countryPrefix),
    documentTypes: getDocumentTypes(countryPrefix),
    inputMode: getInputMode(countryPrefix),
  };
};
